<template>
  <div>
    考勤统计
  </div>
</template>

<script>
export default {
  name: "Home"
}
</script>

<style scoped>

</style>